/* tslint:disable */
/* eslint-disable */
/**
 * 不系舟 (lfr-unmoored) API
 * Family Hub 后端 API — Go 重写版。  Phase 2 codegen-ready 版本（SPEC-1..SPEC-9 完成）： - 全 path 带 operationId（驼峰命名） - 4xx/5xx 统一响应 ErrorResponse - 时间字段统一 date-time（RFC3339） - schema 标 required - request body 抽出命名 schema（XxxCreateRequest / XxxUpdateRequest） - v2.1.1 (BE-S5-002): content/text 字段加 description，明确语义边界 - v2.6.0 (BE-S11-001): 新增日程模块 /api/schedule/items（单日/区间查询、单条 CRUD、   批量整周替换、DDL 截止前一天提醒），数据按 X-User 隔离 - v2.7.0 (BE-TD-001): 既有漂移治理——补齐 68 个已上线 BE 路由（okr/memo/meetings/   tasks/shares/packing/travel/health/growth/agent/metrics/auth/todo 13 域），   listGrowth 返回类型修正为 map（对齐生产实现），spec ↔ BE 恢复 1:1 - v2.8.0: 日程新增 meal 类型；training / meal 通过 note 传递结构化计划详情 - v2.9.0: 日程新增 category 字段，删除「其他」兜底分区；所有事项必须归类为   timeline|work_plan|training_plan|meal_plan|life - v2.10.0: 新增自省语录 /api/okr/reflection（与 /api/okr/backdrop 同构，独立表） - v2.11.0 (PRD v3 待办+日程合并): /api/work/todo 升级为统一任务查询——新增   date/from/to 日历区间、status（含 overdue/held/pending 特殊口径）、type/tag 过滤，   新增 GET /api/work/todo/{id}；Todo schema 补 type/category/tag/url/startDate/   deadline/time/remindBefore/remindedAt/heldSince/createdAt/updatedAt，status 统一   6 值枚举（in_progress 下划线）；/api/schedule/items 转为过渡期别名（数据源=todos   单表，响应契约不变，标记 deprecated） 
 *
 * The version of the OpenAPI document: 2.13.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeleteDiary200Response } from '../models';
// @ts-ignore
import type { DiaryCreateRequest } from '../models';
// @ts-ignore
import type { DiaryEntry } from '../models';
// @ts-ignore
import type { DiaryUpdateRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetEarliestYear200Response } from '../models';
// @ts-ignore
import type { ListDiary200Response } from '../models';
/**
 * DiaryApi - axios parameter creator
 * @export
 */
export const DiaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a diary entry
         * @param {DiaryCreateRequest} diaryCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiary: async (diaryCreateRequest: DiaryCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'diaryCreateRequest' is not null or undefined
            assertParamExists('createDiary', 'diaryCreateRequest', diaryCreateRequest)
            const localVarPath = `/api/life/diary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diaryCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a diary entry (idempotent)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiary: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDiary', 'id', id)
            const localVarPath = `/api/life/diary/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a diary entry by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiary: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDiary', 'id', id)
            const localVarPath = `/api/life/diary/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the earliest year that has diary entries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarliestYear: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/life/diary/earliest-year`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List recent diary entries (optional year/month filter)
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {number} [year] 按年过滤（服务端走 ListByMonth，忽略 cursor）
         * @param {number} [month] 按月过滤（需与 year 同传；缺省&#x3D;全年）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiary: async (cursor?: string, limit?: number, year?: number, month?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/life/diary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update (write) a diary entry
         * @param {string} id 
         * @param {DiaryUpdateRequest} diaryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiary: async (id: string, diaryUpdateRequest: DiaryUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDiary', 'id', id)
            // verify required parameter 'diaryUpdateRequest' is not null or undefined
            assertParamExists('updateDiary', 'diaryUpdateRequest', diaryUpdateRequest)
            const localVarPath = `/api/life/diary/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diaryUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiaryApi - functional programming interface
 * @export
 */
export const DiaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a diary entry
         * @param {DiaryCreateRequest} diaryCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDiary(diaryCreateRequest: DiaryCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiaryEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDiary(diaryCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiaryApi.createDiary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a diary entry (idempotent)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDiary(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteDiary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDiary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiaryApi.deleteDiary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a diary entry by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiary(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiaryEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiaryApi.getDiary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the earliest year that has diary entries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEarliestYear(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEarliestYear200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEarliestYear(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiaryApi.getEarliestYear']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List recent diary entries (optional year/month filter)
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {number} [year] 按年过滤（服务端走 ListByMonth，忽略 cursor）
         * @param {number} [month] 按月过滤（需与 year 同传；缺省&#x3D;全年）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDiary(cursor?: string, limit?: number, year?: number, month?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDiary(cursor, limit, year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiaryApi.listDiary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update (write) a diary entry
         * @param {string} id 
         * @param {DiaryUpdateRequest} diaryUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDiary(id: string, diaryUpdateRequest: DiaryUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiaryEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDiary(id, diaryUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiaryApi.updateDiary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiaryApi - factory interface
 * @export
 */
export const DiaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiaryApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a diary entry
         * @param {DiaryApiCreateDiaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiary(requestParameters: DiaryApiCreateDiaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiaryEntry> {
            return localVarFp.createDiary(requestParameters.diaryCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a diary entry (idempotent)
         * @param {DiaryApiDeleteDiaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiary(requestParameters: DiaryApiDeleteDiaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteDiary200Response> {
            return localVarFp.deleteDiary(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a diary entry by id
         * @param {DiaryApiGetDiaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiary(requestParameters: DiaryApiGetDiaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiaryEntry> {
            return localVarFp.getDiary(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the earliest year that has diary entries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarliestYear(options?: RawAxiosRequestConfig): AxiosPromise<GetEarliestYear200Response> {
            return localVarFp.getEarliestYear(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List recent diary entries (optional year/month filter)
         * @param {DiaryApiListDiaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiary(requestParameters: DiaryApiListDiaryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListDiary200Response> {
            return localVarFp.listDiary(requestParameters.cursor, requestParameters.limit, requestParameters.year, requestParameters.month, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update (write) a diary entry
         * @param {DiaryApiUpdateDiaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiary(requestParameters: DiaryApiUpdateDiaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiaryEntry> {
            return localVarFp.updateDiary(requestParameters.id, requestParameters.diaryUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DiaryApi - interface
 * @export
 * @interface DiaryApi
 */
export interface DiaryApiInterface {
    /**
     * 
     * @summary Create a diary entry
     * @param {DiaryApiCreateDiaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApiInterface
     */
    createDiary(requestParameters: DiaryApiCreateDiaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiaryEntry>;

    /**
     * 
     * @summary Delete a diary entry (idempotent)
     * @param {DiaryApiDeleteDiaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApiInterface
     */
    deleteDiary(requestParameters: DiaryApiDeleteDiaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteDiary200Response>;

    /**
     * 
     * @summary Get a diary entry by id
     * @param {DiaryApiGetDiaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApiInterface
     */
    getDiary(requestParameters: DiaryApiGetDiaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiaryEntry>;

    /**
     * 
     * @summary Get the earliest year that has diary entries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApiInterface
     */
    getEarliestYear(options?: RawAxiosRequestConfig): AxiosPromise<GetEarliestYear200Response>;

    /**
     * 
     * @summary List recent diary entries (optional year/month filter)
     * @param {DiaryApiListDiaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApiInterface
     */
    listDiary(requestParameters?: DiaryApiListDiaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDiary200Response>;

    /**
     * 
     * @summary Update (write) a diary entry
     * @param {DiaryApiUpdateDiaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApiInterface
     */
    updateDiary(requestParameters: DiaryApiUpdateDiaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiaryEntry>;

}

/**
 * Request parameters for createDiary operation in DiaryApi.
 * @export
 * @interface DiaryApiCreateDiaryRequest
 */
export interface DiaryApiCreateDiaryRequest {
    /**
     * 
     * @type {DiaryCreateRequest}
     * @memberof DiaryApiCreateDiary
     */
    readonly diaryCreateRequest: DiaryCreateRequest
}

/**
 * Request parameters for deleteDiary operation in DiaryApi.
 * @export
 * @interface DiaryApiDeleteDiaryRequest
 */
export interface DiaryApiDeleteDiaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DiaryApiDeleteDiary
     */
    readonly id: string
}

/**
 * Request parameters for getDiary operation in DiaryApi.
 * @export
 * @interface DiaryApiGetDiaryRequest
 */
export interface DiaryApiGetDiaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DiaryApiGetDiary
     */
    readonly id: string
}

/**
 * Request parameters for listDiary operation in DiaryApi.
 * @export
 * @interface DiaryApiListDiaryRequest
 */
export interface DiaryApiListDiaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DiaryApiListDiary
     */
    readonly cursor?: string

    /**
     * 
     * @type {number}
     * @memberof DiaryApiListDiary
     */
    readonly limit?: number

    /**
     * 按年过滤（服务端走 ListByMonth，忽略 cursor）
     * @type {number}
     * @memberof DiaryApiListDiary
     */
    readonly year?: number

    /**
     * 按月过滤（需与 year 同传；缺省&#x3D;全年）
     * @type {number}
     * @memberof DiaryApiListDiary
     */
    readonly month?: number
}

/**
 * Request parameters for updateDiary operation in DiaryApi.
 * @export
 * @interface DiaryApiUpdateDiaryRequest
 */
export interface DiaryApiUpdateDiaryRequest {
    /**
     * 
     * @type {string}
     * @memberof DiaryApiUpdateDiary
     */
    readonly id: string

    /**
     * 
     * @type {DiaryUpdateRequest}
     * @memberof DiaryApiUpdateDiary
     */
    readonly diaryUpdateRequest: DiaryUpdateRequest
}

/**
 * DiaryApi - object-oriented interface
 * @export
 * @class DiaryApi
 * @extends {BaseAPI}
 */
export class DiaryApi extends BaseAPI implements DiaryApiInterface {
    /**
     * 
     * @summary Create a diary entry
     * @param {DiaryApiCreateDiaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApi
     */
    public createDiary(requestParameters: DiaryApiCreateDiaryRequest, options?: RawAxiosRequestConfig) {
        return DiaryApiFp(this.configuration).createDiary(requestParameters.diaryCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a diary entry (idempotent)
     * @param {DiaryApiDeleteDiaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApi
     */
    public deleteDiary(requestParameters: DiaryApiDeleteDiaryRequest, options?: RawAxiosRequestConfig) {
        return DiaryApiFp(this.configuration).deleteDiary(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a diary entry by id
     * @param {DiaryApiGetDiaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApi
     */
    public getDiary(requestParameters: DiaryApiGetDiaryRequest, options?: RawAxiosRequestConfig) {
        return DiaryApiFp(this.configuration).getDiary(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the earliest year that has diary entries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApi
     */
    public getEarliestYear(options?: RawAxiosRequestConfig) {
        return DiaryApiFp(this.configuration).getEarliestYear(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List recent diary entries (optional year/month filter)
     * @param {DiaryApiListDiaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApi
     */
    public listDiary(requestParameters: DiaryApiListDiaryRequest = {}, options?: RawAxiosRequestConfig) {
        return DiaryApiFp(this.configuration).listDiary(requestParameters.cursor, requestParameters.limit, requestParameters.year, requestParameters.month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update (write) a diary entry
     * @param {DiaryApiUpdateDiaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiaryApi
     */
    public updateDiary(requestParameters: DiaryApiUpdateDiaryRequest, options?: RawAxiosRequestConfig) {
        return DiaryApiFp(this.configuration).updateDiary(requestParameters.id, requestParameters.diaryUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

